import React, { Component } from "react";
import "./PlusButton.css";

class PlusButton extends Component {
  render() {
    return (
      <div
        className={`plus-button ${this.props.type} ${this.props.concern
          .status}`}
      >
        <span>+</span>
      </div>
    );
  }
}

export default PlusButton;



// WEBPACK FOOTER //
// ./src/components/PlusButton.js